import UserAutocompleteInput from '../inputs/UserAutocompleteInput';
import createField from './createField';

const UserAutocompleteField = createField(UserAutocompleteInput);

export default UserAutocompleteField;
